import React from 'react';

import { Link, Typography } from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

const ContactFormatter = ({ row }) => {
    const contact = get(row, 'contact', null);

    if (!contact || !contact.id) {
        return <Typography variant="caption">---</Typography>;
    }

    return (
        <Link
            color="inherit"
            component={RouterLink}
            to={`/contacts/${contact.id}`}
            underline="none"
        >
            <Typography fontWeight={600} variant="caption">
                {contact.name}
            </Typography>
        </Link>
    );
};

ContactFormatter.propTypes = {
    row: PropTypes.object,
};

export default ContactFormatter;
